var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9252 8.62839C2.08707 7.79568 1.66759 6.70431 1.66675 5.61295C1.66591 4.51825 2.08539 3.42355 2.9252 2.5875C4.6023 0.918749 7.32223 0.918749 9.00017 2.5875C10.6773 0.918749 13.3972 0.918749 15.0751 2.5875C15.9661 3.47361 16.3839 4.65175 16.3286 5.81153C16.2791 6.83615 15.8612 7.84574 15.0751 8.62839L9.00017 14.6693L2.9252 8.62839Z",
    stroke: "#006CFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 7.33594H6.99992L8.33325 5.33594L9.66659 9.33594L10.9999 7.33594H11.6666",
    stroke: "#006CFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/heart-rate.41cd7787853882500af44f5982f75c1f.svg";
export { ForwardRef as ReactComponent };